import React, { useEffect, useState } from 'react';
import { PDFReader } from '@punchcard/core';
import { FormProvider, useForm, } from 'react-hook-form';

interface IProps {
	pageNumbers: string;
	documentUrl: string;
	jsonUrl: string;
	isPrinting?: boolean;
	setDocumentReady?: () => void;
	selectedPages?: number[];
	setSelectedPages?: React.Dispatch<React.SetStateAction<number[]>>;
	isFinalGrade?: boolean;
	isWorkSampleReview?: boolean;
	isPdfGeneratingView?: boolean;
	isPreparing?: boolean;
}

const WorkSampleDisplay = (props: IProps) => {
	const { documentUrl, jsonUrl, pageNumbers, setDocumentReady, selectedPages, setSelectedPages, isFinalGrade, isWorkSampleReview, isPdfGeneratingView } = props;
	const [pdfData, setPdfData] = useState<File | null>(null);
	const newActivityAssessment: currentActivityAssessment = {
		type: 'Activity',
		item: {
			id: 0,
			courseId: 0,
			courseUnitId: 0,
			courseLessonId: undefined,
			activityName: '',
			assessmentName: '',
			sortOrder: 0,
			pageNumbers: pageNumbers, // Set this explicitly
			gradeValue: undefined,
			questionsAnswered: undefined,
			gradeReceived: undefined,
			assessmentType: [],
			instructions: '',
			version: '',
			comments: '',
			activityStatus: {} as StudentActivityStatusDTO, // Empty object casted to the correct type
			courseDocuments: [],
			courseActivityTags: []
		}
	};
	const methods = useForm<WIPForm>({
		defaultValues: {
			undoHistory: [],
			undoIndex: null,
			lastAction: null,
		},
	});
	useEffect(() => {
		const downloadPDF = async () => {
			if (documentUrl !== undefined) {
				try {
					const response = await fetch(documentUrl);
					if (!response.ok) {
						throw new Error(`error fetching document: ${documentUrl}`);
					}
					const blob = await response.blob();
					const document = new File([blob], 'document.pdf', { type: 'application/pdf' });
					setPdfData(document);
				} catch (error) {
					console.error('Error fetching documents:', error);
				}
			}
		};
		downloadPDF();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [documentUrl]);

	const loadStudentLayer = async () => {
		if (jsonUrl !== null && jsonUrl !== undefined) {
			try {
				const response = await fetch(jsonUrl);
				if (!response.ok) {
					throw new Error(`Error fetching JSON document: ${jsonUrl}`);
				}
				const blob = await response.blob();
				const jsonFile = new File([blob], 'studentlayer.json', { type: blob.type });
				const paths = await jsonFile.text();
				const jsonData = paths ? JSON.parse(paths) as ILayerPaths[] : [];
				methods.reset({
					studentLayer: jsonData,
					undoHistory: [],
					undoIndex: null,
					lastAction: null
				});
			} catch (error) {
				console.error('Error loading student layer:', error);
			}
		}
	};

	const documentLoadSuccess = () => {
		loadStudentLayer();
	};

	const renderPage = () => {
		if (pdfData) {
			return (
				<PDFReader
					pdfData={pdfData}
					documentLoadSuccess={documentLoadSuccess}
					isPrinting={props.isPrinting}
					setCurrentActivity={() => { }}
					currentActivity={newActivityAssessment}
					isActivityOpen={true}
					setDocumentReady={setDocumentReady}
					selectedPages={selectedPages}
					setSelectedPages={setSelectedPages}
					isFinalGrade={isFinalGrade}
					isWorkSampleReview={isWorkSampleReview}
					isPdfGeneratingView={isPdfGeneratingView}
					isPreparing={props.isPreparing}
				/>
			);
		}
		return (
			<React.Fragment ></React.Fragment>
		);
	};

	return (
		<FormProvider {...methods}>
			{renderPage()}
		</FormProvider>
	);
};

export default WorkSampleDisplay;